<script>
	import {sQuery as sq} from './sq.js';
	import {update, sync_scroll, check_tab} from './Sq_editor.js';
	import {g_codes} from './codeSamples.js';
	export let cname, mh = 0, autoload = false, bOnlyCode = false;
	let sq_code = safe_sq_code( g_codes[ cname ] )
	let style = ''
	if ( mh )
	{
		style = `max-height:${mh}px;`
	}

	function safe_sq_code( t ){
		if ( !t )
			t = ''
		let v = 'script src="squery.min.js"></script'
		v = '<' + v + '>\n'
		if ( !t.includes('squery.min.js') && !t.includes('./sq.min.js') )
			t = t.replace('<script>', v + '<script>')
		return t.trim()
	}

	function registerEvents( bAutoLoad = false, bOnlyCode = false ){
		const pel = sq(`.cCodeCont[data-cname="${cname}"]`)
		if ( bOnlyCode == '1' ){
			pel.find('#idResult').hide()
			pel.addClass('cFloatLeft')
		} else {
			pel.find('#editing').off('change').on('change', function(){
				//console.log('change')
				let code = pel.find('#editing').val().replace(/'/g,"\\'").replace(/\n/g,"\\n")
				//document.getElementById('idResult').contentWindow.document.write(code);
				let myIFrame = pel.find('#idResult').get(0)
				//console.log(bAutoLoad)
				if ( bAutoLoad ){
					myIFrame.src=`javascript: '${code}'`
				} else {
					pel.find('#idResult')
						//.attr('data-code', code)
						.attr('src', `javascript: '<div style="display:flex;align-items: center; justify-content: center;height:100%"><div style="max-width:200px;color:#fff;background-color:#2196f3;padding:20px">Tap or mouseover to load!</div></div>'`)
						.on('mouseover', function(){
							const code = pel.find('#editing').val().replace(/'/g,"\\'").replace(/\n/g,"\\n")
							//console.log(code)
							sq(this).attr('src', `javascript: '${code}'`)
							sq(this).off('mouseover')
						})
				}
			})
		}
		
		pel.find('#editing').off('input').on('input', function(){
			//console.log('input')
			update(this.value, pel)
			sync_scroll(this, pel)
		})
		pel.find('#editing').off('keydown').on('keydown', function(e){
			//console.log('keydown')
			bAutoLoad = true
			switch(e.keyCode){
				case 9:
					window.bTab = true
					e.preventDefault()
                    return false;
                case 16:
                    window.bShift = true
					e.preventDefault()
                    return false;
                case 17:
					window.bCtrl = true
					e.preventDefault()
					return false;
            }
			if ( !e.key.toLowerCase().includes('arrow') )
			{
				setTimeout(()=>{
					sq(this).trg('change')
				},1)
			}
		})
		pel.find('#editing').off('keyup').on('keyup', function(e){
			//console.log('keyup' )
			check_tab(this, e, pel)
			switch(e.keyCode){
				case 9:
					return false
                case 16:
                    window.bShift = false
                    return false
                case 17:
					window.bCtrl = false
					return false
            }
		})
		pel.find('#editing').off('scroll').on('scroll', function(e){
			sync_scroll(this, pel)
		})

	}

	let c = ``
	let loadProc = function(){
		const pel = sq(`.cCodeCont[data-cname="${cname}"]`)
		sq('body').show()

		setTimeout(()=>{
			pel.find('textarea').val(sq_code)
			update(sq_code, pel)
			pel.find('#editing').trg('change')
			//console.log(sq_code)
		}, 100)

		registerEvents( autoload, bOnlyCode )
		pel.find('#editing').val(c).trg('input').trg('change')
		sq('#idDoc').css({
			'width': '100%',
			'max-width': '100%'
		})
		pel.find('.cF').contains('editor').addClass('active')
	}

	if (sq().isPageLoaded())
	{
		console.log('spa loaded')
		setTimeout(() => {
			loadProc()
		}, 1);
	}
	sq(()=>{
		loadProc()
	})
</script>

<main>
	<link rel="preconnect" href="https://fonts.googleapis.com">
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
	<link href="https://fonts.googleapis.com/css2?family=Source+Code+Pro:wght@300&display=swap" rel="stylesheet">

	<link rel="stylesheet" href="./Docs.css">
	<link rel="stylesheet" href="./Sq_editor.css">
	<section class="cCodeCont" data-cname="{cname}" {style}>
		<div class="cCodeSpace">
			<textarea placeholder="Enter HTML Source Code" id="editing" spellcheck="false"></textarea>
			<pre id="highlighting" aria-hidden="true">
				<code class="language-html" id="highlighting-content"></code>
			</pre>
		</div>
		<!--textarea id="idCode" contenteditable="true"></textarea-->
		<iframe id="idResult" title="editor"></iframe>
	</section>
		
</main>

<style>
	.cCodeSpace, #idResult {
		width: calc(50% - 10px);
		max-width: 1500px;
		border: 2px solid #afe5ff;
	}
	.cCodeSpace {
		border: 2px solid #000;
	}

	@media (max-width: 1000px) {
		.cCodeSpace, #idResult {
			margin: 0;
		}
	}

	@media (max-width: 840px) {
		.cCodeSpace, #idResult {
			width: 100%;
			margin: 0;
		}
		#idResult {
			margin-top: 4px;
		}
	}
</style>